/**
 * The chips (or a caller's own per-workshop rendering) shown in one day cell.
 * Split out of `WorkshopsCalendarDayCell` to keep that component's render
 * function under the file's line cap.
 */
import { Fragment } from 'react';
import type { ReactElement } from 'react';

import { useWorkshopRenderSlot } from './workshops-calendar-render-context';
import { WorkshopsCalendarChip } from './WorkshopsCalendarChip';
import type { WorkshopChip, WorkshopClickHandler } from './workshopsCalendarTypes';

export interface WorkshopsCalendarDayCellChipsProps {
  workshops: WorkshopChip[];
  view: 'Month' | 'Week';
  /** Dense Month days collapse to the compact row until hovered. */
  compact: boolean;
  onWorkshopClick?: WorkshopClickHandler;
}

export function WorkshopsCalendarDayCellChips({
  workshops,
  view,
  compact,
  onWorkshopClick,
}: WorkshopsCalendarDayCellChipsProps): ReactElement {
  const renderWorkshop = useWorkshopRenderSlot();
  return (
    <>
      {workshops.map((w) =>
        renderWorkshop ? (
          <Fragment key={w.id}>
            {renderWorkshop({ workshop: w, view, compact, onWorkshopClick })}
          </Fragment>
        ) : (
          <WorkshopsCalendarChip
            key={w.id}
            workshop={w}
            view={view}
            compact={compact}
            onWorkshopClick={onWorkshopClick}
          />
        ),
      )}
    </>
  );
}
